export type Gender = 'male' | 'female' | 'other'

export interface TeamMember {
  id: string
  name: string
  role: string
  bio?: string
  /** Local compressed photo in public/team/ (e.g. /team/nishu.webp) */
  image: string
  gender?: Gender
  linkedin?: string
}

/** Team photos: compressed WebP in public/team/. Source images in public/team/source/ — run npm run compress-team to regenerate. */
const teamPhoto = (id: string) => `/team/${id}.webp`

export const teamMembers: TeamMember[] = [
  {
    id: 'nishu',
    name: 'Nishu Agrawal',
    role: 'Co-Founder & CEO',
    image: teamPhoto('nishu'),
    gender: 'male',
    bio: 'Loves turning messy ideas into clear systems. Believes growth should feel human, not robotic.',
    linkedin: 'https://linkedin.com', // CEO only
  },
  {
    id: 'darpan',
    name: 'Darpan Shrivastav',
    role: 'Co-Founder & COO',
    image: teamPhoto('darpan'),
    gender: 'male',
    bio: 'Keeps the engine running and the chaos at bay. Strategy by day, systems nerd by choice.',
    linkedin: 'https://linkedin.com', // COO only
  },
  {
    id: 'adityaraj',
    name: 'Adityaraj Singh',
    role: 'Meta Ads Expert',
    bio: 'Adityaraj specializes in performance marketing through Meta Ads, with extensive experience in generating high-quality leads across multiple industries.',
    image: teamPhoto('adityaraj'),
    gender: 'male',
  },
  {
    id: 'poonam',
    name: 'Poonam Salunke',
    role: 'Social Media Executive',
    bio: 'Poonam focuses on building consistent and engaging digital presence for brands through strategic social media management.',
    image: teamPhoto('poonam'),
    gender: 'female',
  },
  {
    id: 'rushit',
    name: 'Rushit Vaghasiya',
    role: 'Senior Graphic Designer',
    bio: 'Rushit brings visual clarity to brand communication through thoughtful and impactful design.',
    image: teamPhoto('rushit'),
    gender: 'male',
  },
  {
    id: 'disha',
    name: 'Disha Patel',
    role: 'Senior Social Media Strategist',
    bio: 'Disha leads content strategy and social media planning to ensure brands communicate effectively with their audience.',
    image: teamPhoto('disha'),
    gender: 'female',
  },
  {
    id: 'om',
    name: 'OM Purohit',
    role: 'Video Editor',
    bio: 'OM creates engaging visual content that strengthens brand storytelling and improves digital engagement.',
    image: teamPhoto('om'),
    gender: 'male',
  },
  {
    id: 'jaimik',
    name: 'Jaimik Patel',
    role: 'Website Developer and AI Expert',
    bio: 'Builds fast, modern websites and brings AI-powered solutions to digital products and workflows.',
    image: teamPhoto('jaimik'),
    gender: 'male',
  },
  {
    id: 'aditya-shah',
    name: 'Aditya Shah',
    role: 'SEO Expert',
    bio: 'Aditya drives organic visibility and long-term search growth through structured SEO strategy and technical optimization.',
    image: teamPhoto('aditya-shah'),
    gender: 'male',
  },
]
